import { z } from 'zod';
import { transformAndFilterValidItems } from '../../../common/tools/transformUtils';

export const OfficeSchema = z
    .object({
        id: z.string(),
        key: z.string(),
        name: z.string(),
        phone: z.string().nullable(),
        email: z.string().nullable(),
        salesAddressLine1: z.string().nullable(),
        salesAddressLine2: z.string().nullable(),
        salesAddressLine3: z.string().nullable(),
        country: z.object({
            id: z.string(),
        }),
        logo: z
            .object({
                fullpath: z.string(),
            })
            .nullable(),
    })
    .describe('OfficeSchema');

export const GetOfficesListingSchema = z
    .object({
        getObjectFolder: z.object({
            children: z
                .array(z.unknown())
                .transform((offices) => transformAndFilterValidItems(OfficeSchema, offices)),
        }),
    })
    .describe('GetOfficesListingSchema');
